import { iconMap } from './IconMap'

const Icon = ({ iconCode, style }) => {
  return (
    <>
      <img
        className='container-weather-icon'
        src={iconCode && iconMap[iconCode].src}
        title={iconCode && iconMap[iconCode].alt}
      />
      <style jsx>{style}</style>
    </>
  )
}

export default Icon
